import React from 'react';
import { SkeletonLoader } from './SkeletonLoader';

interface SkeletonTablePanelProps {
    columnLength: number;
    enabledPaper?: boolean;
}

export const SkeletonTablePanel: React.FC<SkeletonTablePanelProps> = ({
    columnLength,
    enabledPaper = true,
}) => (
    <SkeletonLoader
        variant="panel"
        columns={columnLength}
        rows={2}
        wrapInPaper={enabledPaper}
    />
);
